<div class="main-container">
  <div class="inner-container" >
    <ng-container *ngIf="pdfURL">
      <iframe [src]="pdfURL" type="application/pdf" class="pdf-viewer">
      </iframe>
    </ng-container>
  </div>
  <app-spinner *ngIf="showSpinner"></app-spinner>
</div>